import { createFileRoute } from '@tanstack/react-router';
import { OverviewWorkflowRoute } from './-route-wrappers';
import { validateWorkflowCanvasSearch } from './-workflow-canvas-search';

/**
 * `/journeys/automations/:campaignId/overview/workflow/actions` — the Workflow tab's address on
 * a campaign past the draft state. It renders the same page as the canonical URL rather than
 * forwarding to it, so a link arriving from another tab lands directly on the canvas.
 */
function JourneysAutomationsOverviewWorkflowActionsRoute() {
  const { campaignId } = Route.useParams();

  return <OverviewWorkflowRoute campaignId={campaignId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/automations/$campaignId/overview/workflow/actions',
)({
  component: JourneysAutomationsOverviewWorkflowActionsRoute,
  validateSearch: validateWorkflowCanvasSearch,
});
